import { useOptionalSession } from './chunk-7QYYSJGW.js';
import * as React from 'react';
import { actorDisplayName } from '@authe/fe-commons/session';
import { jsx } from 'react/jsx-runtime';

var ActorNames = React.createContext(/* @__PURE__ */ new Map());
function ActorNamesProvider({ names, children }) {
  return /* @__PURE__ */ jsx(ActorNames.Provider, { value: names, children });
}
function ActorName({ id, names, missing, className }) {
  const directory = React.useContext(ActorNames);
  const session = useOptionalSession()?.session;
  const local = names?.get(id ?? "")?.trim();
  const name = actorDisplayName(id, { self: session?.user, names: local && local !== id ? names : directory, missing });
  return /* @__PURE__ */ jsx("span", { className, title: id ? `User ID: ${id}` : void 0, children: name });
}
function useActorNameIfKnown(id) {
  const directory = React.useContext(ActorNames);
  const session = useOptionalSession()?.session;
  const subject = id?.trim();
  if (!subject) return void 0;
  const name = actorDisplayName(subject, { self: session?.user, names: directory });
  return name !== subject ? name : void 0;
}

export { ActorName, ActorNamesProvider, useActorNameIfKnown };
//# sourceMappingURL=chunk-W23J47FP.js.map
//# sourceMappingURL=chunk-W23J47FP.js.map